import Vue from 'vue';
import Router from 'vue-router';


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);


export default new Router({
    routes: [
        // {
        //     path: '/',
        //     redirect: '/dashboard'
        // },
        {
            path: '/',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '自述文件' },
            children: [
                // {
                //     path: '/dashboard',
                //     component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                //     meta: { title: '系统首页' }
                // },
                // {
                //     path: '/icon',
                //     component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
                //     meta: { title: '自定义图标' }
                // },


                {
                    path: '/indexTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/indexTable.vue'),
                    meta: { title: '首页' }
                },
                {
                    path: '/table',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/UserTable.vue'),
                    meta: { title: '司机管理' }
                },
                {
                    path: '/OfflinePaymentTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/OfflinePaymentTable.vue'),
                    meta: { title: '线下支付管理' }
                },
                {
                    path: '/insuranceProducts',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/insuranceProducts.vue'),
                    meta: { title: '保险产品' }
                },
                {
                    path: '/banner',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/banner.vue'),
                    meta: { title: '首页轮播图' }
                },
                {
                    path: '/order',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/order.vue'),
                    meta: { title: '保险订单' }
                },
                {
                    path: '/InvoiceApplication',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/InvoiceApplication.vue'),
                    meta: { title: '开票申请' }
                },
                {
                    path: '/WithdrawalApplication',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/WithdrawalApplication.vue'),
                    meta: { title: '提现申请' }
                },


                {
                    path: '/HeadhuntersPool',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/HeadhuntersPool.vue'),
                    meta: { title: '猎头库' }
                },

                        {
                            name: 'SewageTankAlarm',
                            path: '/SewageTankAlarm',
                            component: () => import( '../components/page/alarm/SewageTankAlarm.vue'),
                            meta: { title: '污水罐预警' }
                        },
                        {
                            name: 'CarAlarm',
                            path: '/CarAlarm',
                            component: () => import( '../components/page/alarm/CarAlarm.vue'),
                            meta: { title: '车辆预警' }
                        },
                        {
                            name: 'TransportTankAlarm',
                            path: '/TransportTankAlarm',
                            component: () => import( '../components/page/alarm/TransportTankAlarm.vue'),
                            meta: { title: '运输信息' }
                        },


                        {
                            name: 'EnterpriseTable',
                            path: '/EnterpriseTable',
                            component: () => import( '../components/page/infomanage/EnterpriseTable.vue'),
                            meta: { title: '企业名单' }
                        }
                        , {
                            name: 'SewageTankTable',
                            path: '/SewageTankTable',
                            component: () => import( '../components/page/infomanage/SewageTankTable.vue'),
                            meta: { title: '污水罐管理' }
                        }
                        , {
                            name: 'CarManageTable',
                            path: '/CarManageTable',
                            component: () => import( '../components/page/infomanage/CarManageTable.vue'),
                            meta: { title: '车辆管理' }
                        }
                        , {
                            name: 'OrderAlarm',
                            path: '/OrderAlarm',
                            component: () => import( '../components/page/infomanage/OrderAlarm.vue'),
                            meta: { title: '订单信息' }




                },

                {
                    path: '/UserBackground',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/UserBackgroundTable.vue'),
                    meta: { title: '用户管理' }
                },
                {
                    path: '/MoneyDetailsTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/MoneyDetailsTable.vue'),
                    meta: { title: '费用列表' }
                },
                {
                    path: '/ParamTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/ParamTable.vue'),
                    meta: { title: '系统设置' }
                },

                {
                    path: '/enterpriseTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/infomanage/EnterpriseTable.vue'),
                    meta: { title: '企业名单' }
                },
                {
                    path: '/IndustryTable',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/IndustryTable.vue'),
                    meta: { title: '保险类型管理' }
                },

                {
                    path: '/Post',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/Post.vue'),
                    meta: { title: '岗位管理' }
                },
                {
                    path: '/EnterpriseUser',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/EnterpriseUser.vue'),
                    meta: { title: '企业用户管理' }
                },
                {
                    path: '/deviceGroup',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/deviceGroup.vue'),
                    meta: { title: '设备组管理' }
                },
                {
                    path: '/SpecialRecruit',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/SpecialRecruit.vue'),
                    meta: { title: '专场招聘' }
                },
                {
                    path: '/UserPostList',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/UserPostList.vue'),
                    meta: { title: '简历投递' }
                },
                {
                    path: '/device',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/Device.vue'),
                    meta: { title: '设备管理' }
                },
                {
                    path: '/tabs',
                    component: () => import(/* webpackChunkName: "tabs" */ '../components/page/Tabs.vue'),
                    meta: { title: 'tab选项卡' }
                },
                {
                    path: '/form',
                    component: () => import(/* webpackChunkName: "form" */ '../components/page/BaseForm.vue'),
                    meta: { title: '基本表单' }
                },
                {
                    // 富文本编辑器组件
                    path: '/editor',
                    component: () => import(/* webpackChunkName: "editor" */ '../components/page/VueEditor.vue'),
                    meta: { title: '富文本编辑器' }
                },
                {
                    // markdown组件
                    path: '/markdown',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Markdown.vue'),
                    meta: { title: 'markdown编辑器' }
                },
                {
                    // 图片上传组件
                    path: '/upload',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/Upload.vue'),
                    meta: { title: '文件上传' }
                },
                {
                    // vue-schart组件
                    path: '/charts',
                    component: () => import(/* webpackChunkName: "chart" */ '../components/page/BaseCharts.vue'),
                    meta: { title: 'schart图表' }
                },
                {
                    // 拖拽列表组件
                    path: '/drag',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/DragList.vue'),
                    meta: { title: '拖拽列表' }
                },
                {
                    // 拖拽Dialog组件
                    path: '/dialog',
                    component: () => import(/* webpackChunkName: "dragdialog" */ '../components/page/DragDialog.vue'),
                    meta: { title: '拖拽弹框' }
                },
                {
                    // 国际化组件
                    path: '/i18n',
                    component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
                    meta: { title: '国际化' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
                {
                    path: '/donate',
                    component: () => import(/* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
                    meta: { title: '支持作者' }
                }
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
});

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject)
//         return originalPush.call(this, location, onResolve, onReject);
//     return originalPush.call(this, location).catch((err) => err);
// };
